import React from 'react';
import SignIn from '../SignIn'

const Home = () => {
  return (
    <SignIn />
  )
}

export default Home;